import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { PitchDeck3Page } from './pages/PitchDeck3Page';
import GTMBodyScript from './components/GTMBodyScript';
import GTMHeadScript from './components/GTMHeadScript';
import ClarityScript from './components/ClarityScript';
export function App() {
  return <HelmetProvider data-id="element-0" data-mp="2rkx3hddxwbly">
      <GTMHeadScript data-id="element-1" data-mp="2rkdx8txnjbnr" />
      <GTMBodyScript data-id="element-2" data-mp="2rlozuqfd2dda" />
      <ClarityScript data-id="element-3" data-mp="2rl6t2zv2ogr4" />
      <BrowserRouter data-id="element-4" data-mp="2rikqzfqyatga">
        <Routes data-id="element-5" data-mp="2mmcde6sej8b8">
          <Route path="*" element={<PitchDeck3Page data-id="element-7" data-mp="2mndqshww46w4" />} data-id="element-6" data-mp="2mmvl6uoc8gbj" />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>;
}